import React from "react";
import './style.css'
import SalesSupport from "./SalesSupport";
import TechnicalSupport from "./TechnicalSupport";

const ContactUs = () => {

  return (
    <div className='contact-us-container' id ='contactusSection'>
      <div className='main-container'>
        <br/><br/>
      <div className="contactus-container-title">
      <div className="q-block">Q</div>
        Do you still have questions?</div>
      <br/><br/>
            <div className="contactus-container-title">Contact us</div><br/><br/><br/>
            
            <div className="contact-us-section">
              <SalesSupport/><TechnicalSupport/>
              </div>
            </div><br/><br/><br/><br/><br/>
    </div>
  )
}

export default ContactUs
